export default __webpack_public_path__ + "static/media/payment-method.2da1d67a.svg";